import RegisterLeadsEntity from "../../domain/entities/register_leads_entity";
import { ResponseApi } from "../../../../core/data/api/response_api";

const API_BASE =
  process.env.REACT_APP_API_URL

export const RegisterLeadsModel = {
  async submitLead(data: RegisterLeadsEntity): Promise<ResponseApi> {
    try {
      const payload = data.toJson();

      const response = await fetch(`${API_BASE}/api/v1/leads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify(payload),
      });


      const result = await response.json()

      if (response.status === 401) {
        throw new Error("Captcha inválido ou expirado. Por favor, tente novamente.");
      }

      if (response.status === 429) {
        throw new Error("Muitas tentativas. Aguarde um momento e tente novamente.");
      }

      if (result.statusCode !== 200 && response.status !== 201) {
        throw new Error(result.message);
      }

      return result as ResponseApi;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error("Não foi possível enviar. Tente novamente.");
    }
  },
};
